import { render } from "./CategoryCard.vue?vue&type=template&id=450a41b6"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-zain-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__